// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StripeElement[data-v-a25183e6]{border:1px solid #cfd8dc;border-radius:5px;-webkit-box-shadow:0 1px 3px 0 rgba(48,54,70,.1);box-shadow:0 1px 3px 0 rgba(48,54,70,.1);padding:7px 10px;background-color:#fff}.StripeElement--focus[data-v-a25183e6]{border:1px solid #cfd8dc!important;-webkit-box-shadow:0 0 0 3px #bfdeff!important;box-shadow:0 0 0 3px #bfdeff!important}.StripeElement--webkit-autofill[data-v-a25183e6]{background-color:#f5f7f8!important}", ""]);
// Exports
module.exports = exports;
